/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  apiClient,
  baseURL,
  clearCookie,
  getCookie,
} from "../../api/apiClient";

export const Logout: React.FC = () => {
  SendLogoutApiRequest();
  return <Navigate to="/login" />;
};

const clearUserCredentials = (): boolean => {
  localStorage.removeItem("last_viewed_engagement");
  clearCookie("session_expiry");
  clearCookie("csrf_token");
  clearCookie("mfa_ok");
  clearCookie("user_data");

  return true;
};

export const SendLogoutApiRequest = async () => {
  try {
    clearUserCredentials();
    const response = await apiClient.get(`${baseURL}/auth/cognito-logout/`, {});

    if (response && response.data.logout_url) {
      window.location.href = response.data.logout_url;
      return true;
    }
  } catch (error) {
    return false;
  }
};
